const initHeader = () => {
  // メインビジュアルセクションとヘッダーを取得
  const mvBg = document.getElementById("js-mv-bg");
  const header = document.getElementById("js-header");

  if (!header) return;

  if (!mvBg) {
    header.classList.add("is-no-bg");
    return;
  }

  // メインビジュアルの可視状態を管理するフラグ
  let isMvBgVisible = true;

  // ヘッダーの表示状態を更新する関数
  const updateHeaderVisibility = () => {
    // メインビジュアルがビューポートに入っていない場合にヘッダーを表示
    if (!isMvBgVisible) {
      header.classList.add("is-scrolled");
    } else {
      header.classList.remove("is-scrolled");
    }
  };
  
  // メインビジュアルのIntersectionObserverのオプション
  const mvBgObserverOptions = {
    threshold: 0.2, // 1ピクセルでもビューポートに入ったら発火
  };

  // メインビジュアルセクションの可視状態を監視するコールバック関数
  const mvBgObserverCallback = ([entry]) => {
    isMvBgVisible = entry.isIntersecting; // ビューポートに入っているかを判定
    updateHeaderVisibility(); // ヘッダーの表示状態を更新
  };

  // メインビジュアルセクション用のIntersectionObserverを作成
  const mvBgObserver = new IntersectionObserver(
    mvBgObserverCallback,
    mvBgObserverOptions
  );

  // メインビジュアルセクションを監視対象に追加
  mvBgObserver.observe(mvBg);
};

// type="module"のスクリプトはDOMContentLoadedの後に実行されるため、単純に呼び出すだけで良い
initHeader();